export default [
  { name: '首頁', path: '#'},
  { name: '關於立瑾', path: 'about'},
  { name: '真心構築', path: 'products'},
  { name: '熱銷建案', path: 'hot'},
  { name: '完銷建案', path: 'past?index=1'},
  { name: '最新消息', path: 'news'},
  { name: '工程進度', path: 'process'},
  { name: '聯絡我們', path: 'contacts'},
  // { name: '地圖導航', imgSrc: '', subTitle: '', section: 'google-map', svgSrc: '', mobileOffset: 0 },
]
